import React, {useState} from 'react'
import NavbarAdmin from '../../components/NavbarAdmin';
import { createTheme} from '@mui/material/styles';
import { Container, Box, Button, Typography,TextField,Skeleton,Radio,FormLabel,FormControl,FormControlLabel,RadioGroup } from '@mui/material';
import SaveIcon from "@mui/icons-material/Save";
import csvImage from '../../assets/img/csv.png';
import useMediaQuery from '@mui/material/useMediaQuery';
import dayjs from 'dayjs';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
const theme = createTheme({
    palette: {
      mode: 'light',
    },
  });

const ExportDati = () => {
  const axiosPrivate = useAxiosPrivate();
    const [datainizio, setDatainizio] = useState(null);
    const [datafine, setDatafine] = useState(null);
    const [fileUrl, setFileUrl] = useState(null);
    const [errors, setErrors] = useState({});
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [tipoExport, setTipoExport] = useState('0');
    const [tipoQuestionario,setTipoQuestionario] = useState('0');
    const matches = useMediaQuery("(min-width:600px)");
    const handleChangeTipoExport = (event) => {
        setTipoExport(event.target.value);
      };
    const handleChangeTipoQuestionario = (event) => {
      setTipoQuestionario(event.target.value);
    };
    const handleDatainizioChange = (dataInizio) => {
        setDatainizio(dataInizio);
        };
    const handleDatafineChange = (dataFine) => {
        setDatafine(dataFine);
        };

    const handleExport = async () => {
      setFileUrl(null);
      setError(null);
      setErrors({});
      setLoading(true);
        const validationErrors = validateInputs();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
          }

          try{
            let res = await axiosPrivate.post('api/export/exportDati', {
                datainizio: datainizio,
                datafine: datafine,
                qualeExport: tipoQuestionario,
                tipoExport: tipoExport
            })
            if(res.status === 200){
                setFileUrl(res.data);
            }else if(res.status === 204){
                setError("Nessun dato da esportare per questo intervallo di date");
            }else{
                setError("Errore durante l'esportazione dei dati");
            }
          } catch (error) {
            setError(error)
          }
          setLoading(false);
        


    }
    const validateInputs = () => {
        const errors = {};
    
        if (!datainizio) {
            errors.startDate = "La data di inizio è obbligatoria";
            setLoading(false)
        }
    
        if (!datafine) {
            errors.endDate = "La data di fine è obbligatoria";
            setLoading(false)
        }

        if (datainizio > datafine) {
            errors.startDate = "La data di inizio non può essere maggiore della data di fine";
            setLoading(false)
            }
    
        return errors;
      };
    
    const styles = {
        questionnaireContainer: {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-start',
          padding: '1rem',
        },
        box: {
            display: 'flex',
            flexDirection: 'column',
          width: '100%',
          maxWidth: '800px',
          borderRadius: '8px',
          backgroundColor: theme.palette.action.hover,
          padding: '2rem',
          boxShadow: '0 3px 5px rgba(0, 0, 0, 0.3)',
          justifyContent: 'space-between',
        },
        boxDate: {
        display: 'flex',
          width: '100%',
          justifyContent: 'space-between',
        },
        boxDownload: {
            height: '70px',
            display: 'flex',
            flexDirection: 'row',
              width: '100%',
              justifyContent: 'space-between',
              borderRadius: '8px',
              border: '1px solid #000',
              padding: '0.5rem',
              marginTop: '2rem',
            },
        boxCsvImage: {
            width:50,
            height:50,
            alignSelf:'center',
            marginRight: '1rem',
        },

        button: {
          marginRight: '1rem',
        },
        buttonContainer: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        },
      };
  return (
    <>
    <NavbarAdmin />
    <Container maxWidth="md" sx={styles.questionnaireContainer}>
    <Box sx={{alignSelf:"start"}}>
        <h1>Export Dati</h1>
    </Box>
    <Box sx={styles.box}>
  <FormControl sx={{mb:3}}>
  <FormLabel id="radio-tipo-questionario">Tipo di questionario:</FormLabel>
    <RadioGroup
      aria-labelledby="radio-tipo-questionario-label"
      defaultValue="0"
      name="radio-tipo-questionario"
      
      value={tipoQuestionario}
      onChange={handleChangeTipoQuestionario}
      row
    >
      <FormControlLabel value="0" control={<Radio />} label="Da Voi a Noi" />
      <FormControlLabel value="1" control={<Radio />} label="Degenti" />
    </RadioGroup>
  </FormControl>
  <FormControl sx={{mb:3}}>
  <FormLabel id="radio-tipo-export">Tipo di esportazione:</FormLabel>
    <RadioGroup
      aria-labelledby="radio-tipo-export-label"
      defaultValue="0"
      name="radio-tipo-export"
      row
      value={tipoExport}
      onChange={handleChangeTipoExport}
    >
      <FormControlLabel value="0" control={<Radio />} label="Dati" />
      <FormControlLabel value="1" control={<Radio />} label="Consigli" />
    </RadioGroup>
  </FormControl>
        <Box sx={styles.boxDate}>

        <TextField
          label="Data inizio"
          type="date"
          value={datainizio}
          onChange={(e) => handleDatainizioChange(e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={
            {
                max: dayjs().format('YYYY-MM-DD')
            }}
          error={!!errors.startDate}
          helperText={errors.startDate}
          sx={{width:250}}
          required
        />
        <TextField
          label="Data fine"
          type="date"
          value={datafine}
          onChange={(e) => handleDatafineChange(e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={
            {
              max: dayjs().format('YYYY-MM-DD')
            }}
          error={!!errors.endDate}
          helperText={errors.endDate}
          sx={{width:250}}
          required
        />
            <Button type='submit' variant="contained" color="primary" onClick={handleExport} sx={{maxHeight:56}}>Esporta</Button>
            
        </Box>

        {error && <Typography variant="p" color="error" mt={2}>{error}</Typography>}
        {fileUrl && !loading &&
        <Box sx={styles.boxDownload}>

                <img src={csvImage} alt="csv" style={styles.boxCsvImage}/>
                <Box sx={{width:'90%',alignSelf:'center'}}>
                    <Typography variant="p">{matches ? fileUrl.substring(fileUrl.lastIndexOf('/')+1): '' }</Typography>
                </Box>
                
                <Button
                    sx={{ borderRadius: 2 }}
                    variant="outlined"
                    color="secondary"
                    onClick={() => {
                        window.open(fileUrl, '_blank');
                    }}
                    startIcon={<SaveIcon />}
                >
                    Salva
                </Button>
            
        </Box>
        }

        {loading && 
          <Box sx={styles.boxDownload}>
            <Box style={{ display: 'flex', flexDirection:'row', }}>
                              <Skeleton variant="rectangular" width={50} height={50} animation="wave" />
                              <Typography variant="p" width={200} style={{ marginLeft: 10 }}><Skeleton animation="wave" /></Typography>
                                 
           </Box>
            
             <Skeleton variant="rectangular" width={100} height={50} sx={{ borderRadius: '8px' }} animation="wave" />
        </Box>
        }
 

    </Box>
      </Container>
    </>
  )
}

export default ExportDati